import type { WorkflowItem } from '#models';

// The stored exception type name may carry a use-case suffix such as "(UC1)"; show the business name.
const DISPLAY_NAMES: readonly (readonly [RegExp, string])[] = [
  [/^export volume deviation\b/i, 'Production Deviation'],
  [/^well exception correlation\b/i, 'Well Exception Correlation'],
  [/^well exception$/i, 'Well Exception Correlation'],
];

export function exceptionTypeLabel(item: Pick<WorkflowItem, 'identity' | 'status'>): string {
  const stored = item.identity?.exceptionType?.trim() || item.status || 'Exception';
  return DISPLAY_NAMES.find(([pattern]) => pattern.test(stored))?.[1] ?? stored;
}
